import webapi from '../../api/webapi'
import moment from 'moment'
/**
   通常設定
*/

const state = {
  order_history:[],
  history_page_visible: false,
  order_total: 0,
}

const getters = {
  OrderHistory: state=> state.order_history,
  HistoryPageVisible: state=> state.history_page_visible,
  OrderTotal: state=> state.order_total,
}

// actions
const actions = {
  /**
    オーダーを送信する
  */
  SendOrder({ commit, getters,dispatch}, cart_items) {
    var order_items=[]
    try{
      cart_items.forEach(function(item){
        //放題メニューの商品の場合、最終オーダー時刻を保存する
        if(item.submenu_code!=''){
          dispatch('SetLastOrderTime',{
            code: item.submenu_code,
            time: moment()
          })
        }
        
        //通常商品
        var order_item={
          no: 0,
          code: item.code,
          count: item.count,
        }
        //注文リクエストあり
        var req_index=0
        item.request.forEach(function(req){
          req_index++
          order_item['Request'+req_index+'Count']=req.request_count
        })
        order_items.push(order_item) //オーダーに追加
  
        //構成品あり
        var cate_index=0
        item.category_list.forEach(function(confList){
          confList.configList.forEach(function(conf){
            
            conf.category_item.forEach(function(cate){
              //構成品は個別に商品コードを持っているので、数量が入っているものは
              //他の商品と同様に追加する
              if(cate.count>0){
                //数量あるものだけパラメータに追加
                cate_index++
                var order_item={
                  no: cate_index,
                  code: cate.code,
                  count: cate.count,
                }
                order_items.push(order_item) //構成品毎にオーダーに追加
              }
            })
            
          })
        })
      })
    }catch(e){
      dispatch('showErrorMessage', 'オーダーパラメータ構成時にエラーが発生しました')
      return
    }
    
    
    return new Promise((resolve, reject) => {
      webapi
        .request(
          'order',
          {
            shop_ip:    getters.ShopIP,
            shop_port:  getters.PortNo,
            slip_date:  getters.SlipDate,
            shop_code:  getters.ShopCode,
            slip_no:    getters.SlipNo,
            order_item: order_items,
          }
        )
        .then(result => {
          dispatch("ClearCartItems")
          dispatch('clearSavedCartData')
          resolve('注文を送信しました')
        })
        .catch(errors => {
          debugger
          reject(getters.ConvertAppError(errors))
            //reject('注文が受け付けられませんでした。<br>欠品になった商品がないか確認のうえ、もういちど注文を実行してください。')
        })
      
    })
  },
  /**
    オーダー履歴を取得する
  */
 GetOrderHistory({ commit,getters, dispatch}) {
    return new Promise((resolve, reject) => {
      webapi
        .request(
          'order_history',
          {
            shop_ip:    getters.ShopIP,
            shop_port:  getters.PortNo,
            slip_date:  getters.SlipDate,
            shop_code:  getters.ShopCode,
            slip_no:    getters.SlipNo,
            lang:       getters.currentLang,
          }
        )
        .then(result => {
          commit('updateOrderHistory',result.OrderList.Order)//明細
          commit('updateOrderTotal',result.TotalN)//合計
          resolve(result)
        })
        .catch(errors => {
          dispatch('showErrorMessage', getters.ConvertAppError(errors))
          reject()
        })
      
    })
  },

  SetHistoryPageVisible({commit,dispatch}, visibility){
    if(visibility){
      dispatch('ClearPageTimer')
    }else{
      dispatch('SetPageTimer')
    }
    commit('historyPageVisible', visibility)
  }
}

// mutations
const mutations = {
  updateOrderHistory(state, list) {
    if(Array.isArray(list)){
      state.order_history=list
    }else{
      state.order_history=[list]
    }
    
  },
  updateOrderTotal(state, value) {
    state.order_total=value
  },
  historyPageVisible(state, value) {
    state.history_page_visible=value 
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/order.js